import styled from 'styled-components';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';

// eslint-disable-next-line import/prefer-default-export
export const LinkStyled = styled(Link)`
  margin: 0 auto;
  display: flex;
`;
